import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';
import {useSelector} from 'react-redux';

import {CloneObject, CompareDates, OpenObjectURL} from '../../../utils/helpers';
import { ALERT_TYPE, PATTERNS, ShowToastMessage, TRIBUTO_TYPE, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import VerificacionesGrid from '../VerificacionesGrid';
import {Accordion, CheckboxButton, CheckboxButtonGroup, DatePickerCustom, FormError, FormLabel, InputCuenta, InputEntidad, InputLista} from '../../common';
import DireccionForm, {GetDataDireccion, IsValidDireccion, IsEmptyDireccion} from '../DireccionForm';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {useReporte} from '../../hooks/useReporte';
import {FindComercio} from '../InhumadosGrid/utils';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";


const InhumadoModal = (props) => {

    // se ocultan las siguientes secciones
    const showVelatorio = false
    const showResponsable = false
    const showRegistroCivil = false

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindComercio = (response) => {
        response.json()
            .then((data) => {
                const numeroCuit = (data) ? data.comercio.numeroCuit : ''
                const idCuentaComercioCocheria = (data) ? data.comercio.idCuenta : 0

                formSet({
                    ...formValues,
                    idCuentaComercioCocheria: idCuentaComercioCocheria,
                    numeroCuitCocheria: numeroCuit
                });

            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    const direccionInit = {
        id: props.data.entity.direccion.id,
        entidad: "Inhumado",
        idEntidad: props.data.entity.direccion.idTemporal,
        idTipoGeoreferencia: props.data.entity.direccion.idTipoGeoreferencia,
        idPais: 0,
        idProvincia: 0,
        idLocalidad: 0,
        idZonaGeoreferencia: 0,
        codigoPostal: "",
        calle: "",
        entreCalle1: "",
        entreCalle2: "",
        altura: "",
        piso: "",
        dpto: "",
        referencia: "",
        longitud: 0,
        latitud: 0,
        origen: ""
    }

    const ID_MOTIVO_FALLECIMIENTO_TRAUMATICO = 1170;

    const dataTagger = useSelector(state => state.dataTagger.data);

    const entityInit = {
        id: 0,
        idCementerio: 0,
        nombreDesconocido: false,
        actaDesconocida: false,
        motivoActaDesconocida: '',
        idTipoDocumento: 0,
        numeroDocumento: '',
        apellido: '',
        nombre: '',
        fechaNacimiento: null,
        idGenero: 0,
        idEstadoCivil: 0,
        idNacionalidad: 0,
        fechaDefuncion: null,
        fechaIngreso: null,
        idMotivoFallecimiento: 0,
        numeroDefuncion: '',
        libro: '',
        folio: '',
        idRegistroCivil: 0,
        acta: '',
        idTipoOrigenInhumacion: 0,
        observacionesOrigen: '',
        idEstadoInhumacion: 0,
        idTipoCondicionEspecial: 0,
        fechaEgreso: null,
        fechaTraslado: null,
        idTipoDestinoInhumacion: 0,
        observacionesDestino: '',
        fechaExhumacion: null,
        fechaReduccion: null,
        numeroReduccion: '',
        unidad: '',
        idTipoDocumentoResponsable: 0,
        numeroDocumentoResponsable: '',
        apellidoResponsable: '',
        nombreResponsable: '',
        fechaHoraInicioVelatorio: null,
        fechaHoraFinVelatorio: null,
        idCuentaComercioCocheria: 0,
        numeroCuitCocheria: '',
        direccion: direccionInit,
        verificaciones: []
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        accordions: {
            // velatorio: true //se abre al inicio para que no falle la goereferenciacion (pero por ahora no se muestra)
            velatorio: false
        }
    });

    const [cocheriaOption, setCocheriaOption] = useState('cuenta');

    const getInitialCocheriaOption = (entity) => {
        if (!entity) return 'cuenta';
        const tieneCuenta = !!entity.idCuentaComercioCocheria;
        const tieneCuit = entity.numeroCuitCocheria && entity.numeroCuitCocheria.length > 0;
        if (!tieneCuenta && tieneCuit) return 'cuit';
        return 'cuenta';
    };

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity, accordions: {velatorio: false}}
        });
        formSet({
            nombreDesconocido: props.data.entity.nombreDesconocido ?? false,
            actaDesconocida: props.data.entity.actaDesconocida ?? false,
            motivoActaDesconocida: props.data.entity.motivoActaDesconocida ?? '',
            idTipoDocumento: props.data.entity.idTipoDocumento,
            numeroDocumento: props.data.entity.numeroDocumento,
            apellido: props.data.entity.apellido,
            nombre: props.data.entity.nombre,
            fechaNacimiento: props.data.entity.fechaNacimiento,
            idGenero: props.data.entity.idGenero,
            idEstadoCivil: props.data.entity.idEstadoCivil,
            idNacionalidad: props.data.entity.idNacionalidad,
            fechaDefuncion: props.data.entity.fechaDefuncion,
            fechaIngreso: props.data.entity.fechaIngreso,
            idMotivoFallecimiento: props.data.entity.idMotivoFallecimiento,
            numeroDefuncion: props.data.entity.numeroDefuncion,
            libro: props.data.entity.libro,
            folio: props.data.entity.folio,
            idRegistroCivil: props.data.entity.idRegistroCivil,
            acta: props.data.entity.acta,
            idTipoOrigenInhumacion: props.data.entity.idTipoOrigenInhumacion,
            observacionesOrigen: props.data.entity.observacionesOrigen,
            idEstadoInhumacion: props.data.entity.idEstadoInhumacion,
            idTipoCondicionEspecial: props.data.entity.idTipoCondicionEspecial,
            fechaEgreso: props.data.entity.fechaEgreso,
            fechaTraslado: props.data.entity.fechaTraslado,
            idTipoDestinoInhumacion: props.data.entity.idTipoDestinoInhumacion,
            observacionesDestino: props.data.entity.observacionesDestino,
            fechaExhumacion: props.data.entity.fechaExhumacion,
            fechaReduccion: props.data.entity.fechaReduccion,
            numeroReduccion: props.data.entity.numeroReduccion,
            unidad: props.data.entity.unidad,
            idTipoDocumentoResponsable: props.data.entity.idTipoDocumentoResponsable,
            numeroDocumentoResponsable: props.data.entity.numeroDocumentoResponsable,
            apellidoResponsable: props.data.entity.apellidoResponsable,
            nombreResponsable: props.data.entity.nombreResponsable,
            fechaHoraInicioVelatorio: props.data.entity.fechaHoraInicioVelatorio,
            fechaHoraFinVelatorio: props.data.entity.fechaHoraFinVelatorio,
            idCuentaComercioCocheria: props.data.entity.idCuentaComercioCocheria,
            numeroCuitCocheria: props.data.entity.numeroCuitCocheria,
            verificaciones: props.data.entity.verificaciones
        });
    }
    useEffect(mount, [props.data.entity]);

    useEffect(() => {
        const option = getInitialCocheriaOption(props.data.entity);
        setCocheriaOption(option);
    }, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        nombreDesconocido: false,
        actaDesconocida: false,
        motivoActaDesconocida: '',
        idTipoDocumento: 0,
        numeroDocumento: '',
        apellido: '',
        nombre: '',
        fechaNacimiento: null,
        idGenero: 0,
        idEstadoCivil: 0,
        idNacionalidad: 0,
        fechaDefuncion: null,
        fechaIngreso: null,
        idMotivoFallecimiento: 0,
        numeroDefuncion: '',
        libro: '',
        folio: '',
        idRegistroCivil: 0,
        acta: '',
        idTipoOrigenInhumacion: 0,
        observacionesOrigen: '',
        idEstadoInhumacion: 0,
        idTipoCondicionEspecial: 0,
        fechaEgreso: null,
        fechaTraslado: null,
        idTipoDestinoInhumacion: 0,
        observacionesDestino: '',
        fechaExhumacion: null,
        fechaReduccion: null,
        numeroReduccion: '',
        unidad: '',
        idTipoDocumentoResponsable: 0,
        numeroDocumentoResponsable: '',
        apellidoResponsable: '',
        nombreResponsable: '',
        fechaHoraInicioVelatorio: null,
        fechaHoraFinVelatorio: null,
        idCuentaComercioCocheria: 0,
        numeroCuitCocheria: ''
    });

    const [generateReporte,] = useReporte({
        callback: (reporte, buffer, message) => {
            if (buffer)
                OpenObjectURL(`${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const TIPO_DOCUMENTO_SOLO_NUMEROS = [510, 512, 513, 515]; // DNI: 510, L.E.: 512, L.C.: 513, CUIT: 515

    const requiresOnlyNumbers = (idTipoDocumento) => {
        return TIPO_DOCUMENTO_SOLO_NUMEROS.includes(parseInt(idTipoDocumento));
    };

    const isNumeroDocumentoValid = () => {
        if (!formValues.numeroDocumento) return true;
        if (!requiresOnlyNumbers(formValues.idTipoDocumento)) return true;
        const regex = new RegExp(`^${PATTERNS.onlyNumbers}$`);
        return regex.test(formValues.numeroDocumento);
    };

    const CAMPOS_INHUMADO = ['idTipoDocumento', 'numeroDocumento', 'apellido', 'nombre', 'idGenero', 'fechaDefuncion', 'idMotivoFallecimiento'];
    const CAMPOS_INHUMACION = ['numeroDefuncion', 'motivoActaDesconocida'];
    const [inhumadoOpen, setInhumadoOpen] = useState(true);
    const [inhumacionOpen, setInhumacionOpen] = useState(false);
    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        const errors = { ...getErrors(), ...getFormatErrors() };
        if (CAMPOS_INHUMADO.some(campo => errors[campo])) setInhumadoOpen(true);
        if (CAMPOS_INHUMACION.some(campo => errors[campo])) setInhumacionOpen(true);
        if (!validate()) return;
        if (!isDocumentacionValida()) return;

        let row = CloneObject(state.entity);

        row.nombreDesconocido = formValues.nombreDesconocido;
        row.actaDesconocida = formValues.actaDesconocida;
        row.motivoActaDesconocida = formValues.motivoActaDesconocida;
        row.idTipoDocumento = parseInt(formValues.idTipoDocumento);
        row.numeroDocumento = formValues.numeroDocumento;
        row.apellido = formValues.apellido;
        row.nombre = formValues.nombre;
        row.fechaNacimiento = formValues.fechaNacimiento;
        row.idGenero = parseInt(formValues.idGenero);
        row.idEstadoCivil = parseInt(formValues.idEstadoCivil);
        row.idNacionalidad = parseInt(formValues.idNacionalidad);
        row.fechaDefuncion = formValues.fechaDefuncion;
        row.fechaIngreso = formValues.fechaIngreso;
        row.idMotivoFallecimiento = parseInt(formValues.idMotivoFallecimiento);
        row.numeroDefuncion = formValues.numeroDefuncion;
        row.libro = formValues.libro;
        row.folio = formValues.folio;
        row.idRegistroCivil = parseInt(formValues.idRegistroCivil);
        row.acta = formValues.acta;
        row.idTipoOrigenInhumacion = parseInt(formValues.idTipoOrigenInhumacion);
        row.observacionesOrigen = formValues.observacionesOrigen;
        row.idEstadoInhumacion = parseInt(formValues.idEstadoInhumacion);
        row.idTipoCondicionEspecial = parseInt(formValues.idTipoCondicionEspecial);
        row.fechaEgreso = formValues.fechaEgreso;
        row.fechaTraslado = formValues.fechaTraslado;
        row.idTipoDestinoInhumacion = parseInt(formValues.idTipoDestinoInhumacion);
        row.observacionesDestino = formValues.observacionesDestino;
        row.fechaExhumacion = formValues.fechaExhumacion;
        row.fechaReduccion = formValues.fechaReduccion;
        row.numeroReduccion = formValues.numeroReduccion;
        row.unidad = formValues.unidad;
        row.idTipoDocumentoResponsable = parseInt(formValues.idTipoDocumentoResponsable);
        row.numeroDocumentoResponsable = formValues.numeroDocumentoResponsable;
        row.apellidoResponsable = formValues.apellidoResponsable;
        row.nombreResponsable = formValues.nombreResponsable;
        row.fechaHoraInicioVelatorio = formValues.fechaHoraInicioVelatorio;
        row.fechaHoraFinVelatorio = formValues.fechaHoraFinVelatorio;
        row.idCuentaComercioCocheria = parseInt(formValues.idCuentaComercioCocheria);
        row.numeroCuitCocheria = formValues.numeroCuitCocheria;
        // row.direccion = !IsEmptyDireccion.get("Inhumado_direccion")() ? GetDataDireccion.get("Inhumado_direccion")() : direccionInit;  

        props.onConfirm(row);
    };

    const handleClickReporte = (reporte) => {
        const paramsReporte = {
            idCementerio: state.entity.idCementerio,
            idInhumado: state.entity.id
        }
        generateReporte(reporte, paramsReporte);
    }

    //funciones
    function getErrors() {
        const errors = {};

        if (!formValues.nombreDesconocido) {
            if (formValues.idTipoDocumento <= 0) errors.idTipoDocumento = VALIDATION_MESSAGE.REQUIRED_OPTION;
            if (formValues.numeroDocumento.length === 0) errors.numeroDocumento = VALIDATION_MESSAGE.REQUIRED;
            if (formValues.apellido.length === 0) errors.apellido = VALIDATION_MESSAGE.REQUIRED;
            if (formValues.nombre.length === 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED;
        }
        if (formValues.idGenero <= 0) errors.idGenero = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fechaDefuncion == null) errors.fechaDefuncion = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.idMotivoFallecimiento <= 0) errors.idMotivoFallecimiento = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.actaDesconocida) {
            if (formValues.motivoActaDesconocida.trim().length === 0) errors.motivoActaDesconocida = VALIDATION_MESSAGE.REQUIRED;
        } else {
            if (formValues.numeroDefuncion.length === 0) errors.numeroDefuncion = VALIDATION_MESSAGE.REQUIRED;
        }

        // if (formValues.idTipoOrigenInhumacion <= 0) {
        //     ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar el campo Tipo origen');
        //     return false;
        // }
        // if (formValues.idTipoDestinoInhumacion <= 0) {
        //     ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar el campo Tipo destino');
        //     return false;
        // }

        // const isEmptyDireccion = IsEmptyDireccion.get("Inhumado_direccion")();
        // if (!isEmptyDireccion) {
        //     const isValidDireccion = IsValidDireccion.get("Inhumado_direccion")();
        //     if (!isValidDireccion.result) {
        //         ShowToastMessage(ALERT_TYPE.ALERT_WARNING, isValidDireccion.message);
        //         return false;
        //     }
        // }

        return errors;
    }

    function getFormatErrors() {
        const errors = {};
        if (props.disabled) return errors;

        if (!formValues.nombreDesconocido && !isNumeroDocumentoValid()) errors.numeroDocumento = 'Ingresá sólo números';

        return errors;
    }

    function isDocumentacionValida() {
        const esTraumatico = parseInt(formValues.idMotivoFallecimiento) === ID_MOTIVO_FALLECIMIENTO_TRAUMATICO;
        if (!esTraumatico) return true;

        const archivos = (dataTagger?.[props.processKey]?.Archivo || [])
            .filter(f => f.entidad === "Inhumado" && f.idEntidad === state.entity.id && f.state !== 'r');
        if (archivos.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Los casos de fallecimiento traumático requieren al menos un documento adjunto');
            return false;
        }

        return true;
    }

    const handleNombreDesconocidoChange = (event) => {
        const checked = event.target.checked;
        if (checked) {
            formSet({
                ...formValues,
                nombreDesconocido: true,
                idTipoDocumento: 0,
                numeroDocumento: ''
            });
        } else {
            formSet({
                ...formValues,
                nombreDesconocido: false
            });
        }
    };

    const handleActaDesconocidaChange = (event) => {
        const checked = event.target.checked;
        if (checked) {
            formSet({
                ...formValues,
                actaDesconocida: true,
                numeroDefuncion: '',
                libro: '',
                folio: '',
                acta: ''
            });
        } else {
            formSet({
                ...formValues,
                actaDesconocida: false,
                motivoActaDesconocida: ''
            });
        }
    };

    const handleCocheriaOptionChange = (event) => {
        const value = event.target.value;
        setCocheriaOption(value);

        formSet({
            ...formValues,
            idCuentaComercioCocheria: 0,
            numeroCuitCocheria: ''
        });
    };

    const handleOnlyNumbers = (event) => {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (allowedKeys.includes(event.key)) return;
        if (event.ctrlKey || event.metaKey) return;
        if (!/^[0-9]$/.test(event.key)) {
            event.preventDefault();
        }
    };

    const handleNumeroDocumentoKeyDown = (event) => {
        if (requiresOnlyNumbers(formValues.idTipoDocumento)) {
            handleOnlyNumbers(event);
        }
    };

    return (
        <>

            <Modal
                size="xl"
                title={`Inhumado: ${(state.entity.id > 0) ? `Número de acta ${formValues.numeroDefuncion}` : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.INHUMADO_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Datos del inhumado" open={inhumadoOpen} onToggle={setInhumadoOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12">
                                                <CheckboxButtonGroup label="Identificación">
                                                    <CheckboxButton
                                                        name="nombreDesconocido"
                                                        label="Persona no identificada (NN)"
                                                        checked={formValues.nombreDesconocido}
                                                        onChange={handleNombreDesconocidoChange}
                                                        disabled={props.disabled}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="idTipoDocumento" required={!formValues.nombreDesconocido}>Tipo de
                                                    documento</FormLabel>
                                                <InputLista
                                                    name="idTipoDocumento"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoDocumento') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoDocumento}
                                                    onChange={formHandle}
                                                    disabled={props.disabled || formValues.nombreDesconocido}
                                                    lista="TipoDocumento"
                                                />
                                                <FormError message={errorOf('idTipoDocumento')} />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="numeroDocumento" required={!formValues.nombreDesconocido}>Número de
                                                    documento</FormLabel>
                                                <input
                                                    name="numeroDocumento"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('numeroDocumento') ? 'is-invalid' : ''}`}
                                                    value={formValues.numeroDocumento}
                                                    onChange={formHandle}
                                                    onKeyDown={handleNumeroDocumentoKeyDown}
                                                    disabled={props.disabled || formValues.nombreDesconocido}
                                                />
                                                <FormError message={errorOf('numeroDocumento')} />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="apellido" required={!formValues.nombreDesconocido}>Apellido</FormLabel>
                                                <input
                                                    name="apellido"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('apellido') ? 'is-invalid' : ''}`}
                                                    value={formValues.apellido}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('apellido')} />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="nombre" required={!formValues.nombreDesconocido}>Nombre</FormLabel>
                                                <input
                                                    name="nombre"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                                                    value={formValues.nombre}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('nombre')} />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <label htmlFor="fechaNacimiento" className="form-label">Fecha de
                                                    nacimiento</label>
                                                <DatePickerCustom
                                                    name="fechaNacimiento"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaNacimiento}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="idGenero" required>Género</FormLabel>
                                                <InputLista
                                                    name="idGenero"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idGenero') ? 'is-invalid' : ''}`}
                                                    value={formValues.idGenero}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="Genero"
                                                />
                                                <FormError message={errorOf('idGenero')} />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <label htmlFor="idEstadoCivil" className="form-label">Estado
                                                    civil</label>
                                                <InputLista
                                                    name="idEstadoCivil"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idEstadoCivil}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="EstadoCivil"
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <label htmlFor="idNacionalidad"
                                                       className="form-label">Nacionalidad</label>
                                                <InputEntidad
                                                    name="idNacionalidad"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.NACIONALIDAD_MODAL}
                                                    className="form-control"
                                                    value={formValues.idNacionalidad}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Nacionalidad"
                                                    entidad="Pais"
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="fechaDefuncion" required>Fecha de
                                                    defunción</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaDefuncion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaDefuncion') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaDefuncion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    maxValue={new Date()}
                                                />
                                                <FormError message={errorOf('fechaDefuncion')} />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <label htmlFor="fechaIngreso" className="form-label">Fecha de
                                                    ingreso</label>
                                                <DatePickerCustom
                                                    name="fechaIngreso"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaIngreso}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    maxValue={new Date()}
                                                    minValue={formValues.fechaDefuncion}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <FormLabel htmlFor="idMotivoFallecimiento" required>Motivo
                                                    de fallecimiento</FormLabel>
                                                <InputLista
                                                    name="idMotivoFallecimiento"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idMotivoFallecimiento') ? 'is-invalid' : ''}`}
                                                    value={formValues.idMotivoFallecimiento}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="MotivoFallecimiento"
                                                />
                                                <FormError message={errorOf('idMotivoFallecimiento')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                                <div className="mb-3 col-12">
                                   <Accordion title="Datos de la inhumación" open={inhumacionOpen} onToggle={setInhumacionOpen}>
                                       <div className='row form-basic'>
                                           <div className="mb-3 col-12">
                                               <CheckboxButtonGroup label="Identificación">
                                                   <CheckboxButton
                                                       name="actaDesconocida"
                                                       label="Acta de defunción desconocida"
                                                       checked={formValues.actaDesconocida}
                                                       onChange={handleActaDesconocidaChange}
                                                       disabled={props.disabled}
                                                   />
                                               </CheckboxButtonGroup>
                                           </div>
                                           <div className="mb-3 col-6 col-md-2">
                                               <FormLabel htmlFor="numeroDefuncion" required={!formValues.actaDesconocida}>Número de acta</FormLabel>
                                               <input
                                                   name="numeroDefuncion"
                                                   type="text"
                                                   placeholder=""
                                                   className={`form-control ${errorOf('numeroDefuncion') ? 'is-invalid' : ''}`}
                                                   value={formValues.numeroDefuncion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled || formValues.actaDesconocida}
                                               />
                                               <FormError message={errorOf('numeroDefuncion')} />
                                           </div>
                                           <div className="mb-3 col-6 col-md-1">
                                               <label htmlFor="libro" className="form-label">Libro</label>
                                               <input
                                                   name="libro"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.libro}
                                                   onChange={formHandle}
                                                   disabled={props.disabled || formValues.actaDesconocida}
                                               />
                                               <FormError />
                                           </div>
                                           <div className="mb-3 col-6 col-md-1">
                                               <label htmlFor="folio" className="form-label">Folio</label>
                                               <input
                                                   name="folio"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.folio}
                                                   onChange={formHandle}
                                                   disabled={props.disabled || formValues.actaDesconocida}
                                               />
                                               <FormError />
                                           </div>
                                           <div className="mb-3 col-6 col-md-1">
                                               <label htmlFor="acta" className="form-label">Acta</label>
                                               <input
                                                   name="acta"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.acta}
                                                   onChange={formHandle}
                                                   disabled={props.disabled || formValues.actaDesconocida}
                                               />
                                               <FormError />
                                           </div>
                                           {formValues.actaDesconocida &&
                                               <div className="mb-3 col-12">
                                                   <FormLabel htmlFor="motivoActaDesconocida" required>Motivo por el que no se registra el acta</FormLabel>
                                                   <textarea
                                                       name="motivoActaDesconocida"
                                                       placeholder="Ej.: restos NN sin identificar, inhumación antigua sin documentación"
                                                       className={`form-control ${errorOf('motivoActaDesconocida') ? 'is-invalid' : ''}`}
                                                       rows={2}
                                                       value={formValues.motivoActaDesconocida}
                                                       onChange={formHandle}
                                                       disabled={props.disabled}
                                                   />
                                                   <FormError message={errorOf('motivoActaDesconocida')} />
                                               </div>
                                           }
                                           {showRegistroCivil &&
                                               <div className="mb-3 col-6 col-md-2">
                                                   <label htmlFor="idRegistroCivil" className="form-label">Registro
                                                       civil</label>
                                                   <InputEntidad
                                                       name="idRegistroCivil"
                                                       placeholder=""
                                                       className="form-control"
                                                       value={formValues.idRegistroCivil}
                                                       onChange={formHandle}
                                                       disabled={props.disabled}
                                                       title="Registro civil"
                                                       entidad="RegistroCivil"
                                                   />
                                               </div>
                                           }
                                           <div className="mb-3 col-6 col-md-3">
                                               <label htmlFor="idTipoOrigenInhumacion" className="form-label">Tipo
                                                   origen</label>
                                               <InputLista
                                                   name="idTipoOrigenInhumacion"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.idTipoOrigenInhumacion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                                   lista="TipoOrigenInhumacion"
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-md-4">
                                               <label htmlFor="idTipoCondicionEspecial" className="form-label">Tipo
                                                   condición especial</label>
                                               <InputEntidad
                                                   name="idTipoCondicionEspecial"
                                                   placeholder=""
                                                   tipName={TIPS.NAME.MODALS.TIPO_CONDICION_ESPECIAL_MODAL}
                                                   className="form-control"
                                                   value={formValues.idTipoCondicionEspecial}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                                   title="Tipo Condicion Especial"
                                                   entidad="TipoCondicionEspecial"
                                                   filter={row => !row.idTipoTributo || row.idTipoTributo === TRIBUTO_TYPE.CEMENTERIOS}
                                               />
                                           </div>
                                           <div className="col-12 mt-3 form-check-group">
                                               <div className="form-check form-check-inline">
                                                   <input
                                                       className="form-check-input"
                                                       type="radio"
                                                       id="cocheriaOptionCuenta"
                                                       name="cocheriaOption"
                                                       value="cuenta"
                                                       checked={cocheriaOption === 'cuenta'}
                                                       onChange={handleCocheriaOptionChange}
                                                       disabled={props.disabled}
                                                   />
                                                   <label className="form-check-label"
                                                          htmlFor="cocheriaOptionCuenta">
                                                       Seleccionar cochería
                                                   </label>
                                               </div>
                                               <div className="form-check form-check-inline">
                                                   <input
                                                       className="form-check-input"
                                                       type="radio"
                                                       id="cocheriaOptionCuit"
                                                       name="cocheriaOption"
                                                       value="cuit"
                                                       checked={cocheriaOption === 'cuit'}
                                                       onChange={handleCocheriaOptionChange}
                                                       disabled={props.disabled}
                                                   />
                                                   <label className="form-check-label"
                                                          htmlFor="cocheriaOptionCuit">
                                                       Ingresar CUIT de cochería manualmente
                                                   </label>
                                               </div>
                                           </div>
                                           {cocheriaOption !== 'cuit' && (
                                               <div className="mb-3 col-6 col-md-8">
                                                   <label htmlFor="idCuentaComercioCocheria"
                                                          className="form-label">Cochería</label>
                                                   <InputCuenta
                                                       name="idCuentaComercioCocheria"
                                                       placeholder=""
                                                       className="form-control"
                                                       value={formValues.idCuentaComercioCocheria}
                                                       disabled={props.disabled}
                                                       onChange={(event) => {
                                                           const idTributo = (event.target.row) ? event.target.row.idTributo : 0;

                                                           if (idTributo) {
                                                               const idTributo = (event.target.row) ? event.target.row.idTributo : 0;
                                                               FindComercio(idTributo, callbackSuccessFindComercio, callbackNoSuccess, callbackError)
                                                           } else {
                                                               formSet({
                                                                   ...formValues,
                                                                   idCuentaComercioCocheria: 0,
                                                                   numeroCuitCocheria: ''
                                                               });
                                                           }
                                                       }}
                                                       idTipoTributo={11}
                                                   />
                                               </div>
                                           )}
                                           <div className="mb-3 col-6 col-xl-4">
                                               <label htmlFor="numeroCuitCocheria" className="form-label">Número
                                                   CUIT</label>
                                               <input
                                                   name="numeroCuitCocheria"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.numeroCuitCocheria}
                                                   onChange={formHandle}
                                                   onKeyDown={handleOnlyNumbers}
                                                   disabled={props.disabled || cocheriaOption === 'cuenta'}
                                               />
                                           </div>
                                           <div className="mb-3 col-12">
                                               <label htmlFor="observacionesOrigen" className="form-label">Observaciones
                                                   origen</label>
                                               <input
                                                   name="observacionesOrigen"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.observacionesOrigen}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-4">
                                               <label htmlFor="idEstadoInhumacion" className="form-label">Estado de
                                                   inhumado</label>
                                               <InputLista
                                                   name="idEstadoInhumacion"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.idEstadoInhumacion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                                   lista="EstadoInhumacion"
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-4">
                                               <label htmlFor="idTipoDestinoInhumacion" className="form-label">Tipo
                                                   destino</label>
                                               <InputLista
                                                   name="idTipoDestinoInhumacion"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.idTipoDestinoInhumacion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                                   lista="TipoDestinoInhumacion"
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-4">
                                               <label htmlFor="fechaEgreso" className="form-label">Fecha de
                                                   egreso</label>
                                               <DatePickerCustom
                                                   name="fechaEgreso"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.fechaEgreso}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-4">
                                               <label htmlFor="fechaTraslado" className="form-label">Fecha
                                                   traslado</label>
                                               <DatePickerCustom
                                                   name="fechaTraslado"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.fechaTraslado}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-12">
                                               <label htmlFor="observacionesDestino" className="form-label">Observaciones
                                                   destino</label>
                                               <input
                                                   name="observacionesDestino"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.observacionesDestino}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-3">
                                               <label htmlFor="fechaExhumacion" className="form-label">Fecha de
                                                   exhumación</label>
                                               <DatePickerCustom
                                                   name="fechaExhumacion"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.fechaExhumacion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-3">
                                               <label htmlFor="fechaReduccion" className="form-label">Fecha de
                                                   reducción</label>
                                               <DatePickerCustom
                                                   name="fechaReduccion"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.fechaReduccion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-3">
                                               <label htmlFor="numeroReduccion" className="form-label">Número de
                                                   reducción</label>
                                               <input
                                                   name="numeroReduccion"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.numeroReduccion}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                           <div className="mb-3 col-6 col-xl-1">
                                               <label htmlFor="unidad" className="form-label">Unidad</label>
                                               <input
                                                   name="unidad"
                                                   type="text"
                                                   placeholder=""
                                                   className="form-control"
                                                   value={formValues.unidad}
                                                   onChange={formHandle}
                                                   disabled={props.disabled}
                                               />
                                           </div>
                                       </div>
                                   </Accordion>
                                </div>

                                {showResponsable &&
                                    <>
                                        <div className="mb-3">
                                            <h2 className="modal-title">Responsable:</h2>
                                        </div>

                                        <div className="mb-3 col-6 col-xl-3">
                                            <label htmlFor="idTipoDocumentoResponsable" className="form-label">Tipo de
                                                documento</label>
                                            <InputLista
                                                name="idTipoDocumentoResponsable"
                                                placeholder=""
                                                className="form-control"
                                                value={formValues.idTipoDocumentoResponsable}
                                                onChange={formHandle}
                                                disabled={props.disabled}
                                                lista="TipoDocumento"
                                            />
                                        </div>

                                        <div className="mb-3 col-6 col-xl-3">
                                            <label htmlFor="numeroDocumentoResponsable" className="form-label">Número de
                                                documento</label>
                                            <input
                                                name="numeroDocumentoResponsable"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={formValues.numeroDocumentoResponsable}
                                                onChange={formHandle}
                                                disabled={props.disabled}
                                            />
                                        </div>

                                        <div className="mb-3 col-6 col-xl-3">
                                            <label htmlFor="apellidoResponsable" className="form-label">Apellido</label>
                                            <input
                                                name="apellidoResponsable"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={formValues.apellidoResponsable}
                                                onChange={formHandle}
                                                disabled={props.disabled}
                                            />
                                        </div>

                                        <div className="mb-3 col-6 col-xl-3">
                                            <label htmlFor="nombreResponsable" className="form-label">Nombre</label>
                                            <input
                                                name="nombreResponsable"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={formValues.nombreResponsable}
                                                onChange={formHandle}
                                                disabled={props.disabled}
                                            />
                                        </div>
                                    </>
                                }
                                {showVelatorio &&
                                    <Accordion title="Velatorio">
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <label htmlFor="fechaHoraInicioVelatorio"
                                                       className="form-label">Fecha y hora de inicio</label>
                                                <DatePickerCustom
                                                    name="fechaHoraInicioVelatorio"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaHoraInicioVelatorio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    time={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-6 col-xl-3">
                                                <label htmlFor="fechaHoraFinVelatorio" className="form-label">Fecha
                                                    y hora de fin</label>
                                                <DatePickerCustom
                                                    name="fechaHoraFinVelatorio"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaHoraFinVelatorio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    time={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <DireccionForm
                                                    id="Inhumado_direccion"
                                                    data={{
                                                        entity: state.entity.direccion
                                                    }}
                                                    disabled={props.disabled}
                                                    initFormEdit={(state.entity.direccion.id === 0 && state.entity.direccion.latitud === 0 && state.entity.direccion.longitud === 0)}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                }
                                {(props.showChildren &&
                                    <>
                                        <div className="mb-3 col-12">
                                            <Accordion title="Verificaciones">
                                                <div className='row form-basic'>
                                                    <VerificacionesGrid
                                                        processKey={props.processKey}
                                                        disabled={props.disabled}
                                                        data={{
                                                            idInhumado: state.entity.id,
                                                            list: state.entity.verificaciones
                                                        }}
                                                        onChange={props.onChangeChildren}
                                                    />
                                                </div>
                                            </Accordion>
                                        </div>
                                    </>
                                )}

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Inhumado"
                                            processKey={props.processKey}
                                            entidad="Inhumado"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>


                            </div>
                )}
                footerClassName="modal-footer-unset"
                footer={(<>
                            {state.entity.id > 0 &&
                                <>
                                    <button className="btn task-button float-start" data-dismiss="modal"
                                            onClick={(event) => handleClickReporte("CementerioSolicitudReduccion")}>Solicitud
                                        de reducción
                                    </button>
                                    <button className="btn task-button float-start" data-dismiss="modal"
                                            onClick={(event) => handleClickReporte("CementerioSolicitudInhumacion")}>Solicitud
                                        de inhumación
                                    </button>
                                    <button className="btn task-button float-start" data-dismiss="modal"
                                            onClick={(event) => handleClickReporte("CementerioSolicitudVerificacion")}>Solicitud
                                        de verificación
                                    </button>
                                </>
                            }
                            {!props.disabled && <>
                                <button className="btn btn-primary float-end" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                                <button className="btn btn-outline-primary float-end" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                            </>}
                            {props.disabled &&
                                <button className="btn back-button float-end" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver</button>
                            }
                </>)}
            />

        </>
    );
}

InhumadoModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    onChangeChildren: func.isRequired
};

InhumadoModal.defaultProps = {
    disabled: false
};

export default InhumadoModal;
